import React, { createContext, useState } from 'react'

export const DRAWER_TYPES = {
  CREDIT_ANALYSIS: 'CREDIT_ANALYSIS',
  CREDIT_PAYMENT: 'CREDIT_PAYMENT',
}

export const DRAWERS = {
  [DRAWER_TYPES.CREDIT_ANALYSIS]: {
    open: false,
  },
  [DRAWER_TYPES.CREDIT_PAYMENT]: {
    open: false,
  },
}

export const DrawerContext = createContext()

export const DrawerProvider = ({ children }) => {
  const [drawers, setDrawers] = useState(DRAWERS)

  const openDrawer = drawerType => {
    setDrawers({
      ...drawers,
      [drawerType]: {
        open: true,
      },
    })
  }

  const closeDrawer = drawerType => {
    setDrawers({
      ...drawers,
      [drawerType]: {
        open: false,
      },
    })
  }

  return (
    <DrawerContext.Provider
      value={{
        openDrawer,
        closeDrawer,
        drawers,
      }}
    >
      {children}
    </DrawerContext.Provider>
  )
}
